<template>
  <div class="home_body">
    <el-dialog
  :title="$t('other.a1093')"
  :visible.sync="outstatus"
  width="60%"
  >
  <span>{{$t('other.a1162')}}{{this.formLabelAlign.totalAmount*( (100-this.formLabelAlign.advanceRate)*0.01)}}</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="outstatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="payout">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>

    <el-dialog
  :title="$t('other.a1094')"
  :visible.sync="publicS"
  width="30%"
  >
  <el-form :label-position="labelPosition" label-width="80px" :model="publicdata">
  <el-form-item :label="$t('other.a1108')">
    <el-input v-model="publicdata.advanceRate"></el-input>
  </el-form-item>
  <el-form-item :label="$t('other.a1109')">
    <el-input v-model="publicdata.paymentDeadline"></el-input>
  </el-form-item>
  <!-- <el-form-item label="采购单总金额">
    <el-input v-model="publicdata.totalAmount"></el-input>
  </el-form-item> -->
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="publicS = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="publicSsucceed">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
<el-dialog
  :title="$t('other.a142')"
  :visible.sync="publicD"
  width="30%"
  >
  <span>{{$t('other.a1163')}}:{{this.formLabelAlign.totalAmount}},{{$t('other.a1164')}}: <span style="color:red">{{this.formLabelAlign.advanceRate}}%</span>,{{$t('other.a1165')}}: <span style="color:red">{{this.formLabelAlign.totalAmount * (this.formLabelAlign.advanceRate)*0.01}}</span> {{$t('other.a54')}}</span>
  <span slot="footer" class="dialog-footer">
    <el-button @click="publicD = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="publicDsucceed">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1095')"
  :visible.sync="updateStatus"
  width="30%"
  >
  <el-input v-model="updateValue" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="updateStatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="updatesucced">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1096')"
  :visible.sync="noteStatus"
  width="30%"
  >
  <el-alert
    :title="$t('other.a1097')"
    type="info">
  </el-alert>
  <el-input v-model="noteValue" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="noteStatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="noteSussed">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1098')"
  :visible.sync="propertystatus"
  width="60%"
  >
  <el-form  :inline="true" :model="formInline" class="demo-form-inline">
  <el-form-item :label="$t('other.a1110')">
    <el-input v-model="formInline.user" :placeholder="$t('other.a1110')"></el-input>
  </el-form-item>
  <el-form-item :label="$t('other.a1111')">
    <el-input v-model="formInline.region" :placeholder="$t('other.a1111')"></el-input>
  </el-form-item>
  
</el-form>
  <span slot="footer" class="dialog-footer">
    <el-button @click="propertystatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="propertyadd">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1099')"
  :visible.sync="transitStatus"
  width="50%"
  >
  <el-select
                v-model="transit"
                :placeholder="$t('other.a1112')"
                size="mini"
              >
                <el-option
                  v-for="item in depotData"
                  :key="item.warehouseId"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                >
                </el-option>
              </el-select>
  <span slot="footer" class="dialog-footer">
    <el-button @click="transitStatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="transitsuss
    ">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1100')"
  :visible.sync="supplierStatus"
  width="50%"
  >
  <el-select
                v-model="supplierValue"
                :placeholder="$t('other.a1113')"
               
                
              >
                <el-option
                  v-for="item in gridData"
                  :key="item.id"
                  :label="item.supplier"
                  :value="item.id"
                >
                </el-option>
              </el-select>
  <span slot="footer" class="dialog-footer">
    <el-button @click="supplierStatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="suppliersucced
    ">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1101')"
  :visible.sync="remarkStatus"
  width="30%"
  >
  <el-input v-model="remarkValue" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="remarkStatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="remarksucced">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1102')"
  :visible.sync="waybillStatus"
  width="50%"
  >
  <el-input v-model="waybillnumber" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="waybillStatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="waybillSucces">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1103')"
  :visible.sync="history"
  width="60%"
  >
  <el-table
    :data="historyData"
    border
    style="width: 100%">
    <el-table-column :label="$t('other.a1114')">
          <template slot-scope="scope">
            <span>{{renderTime(scope.row.createdTime) }}</span>
          </template>
        </el-table-column>
    <el-table-column
      prop="auditUserId"
      :label="$t('other.a1115')"
      width="180">
    </el-table-column>
    <el-table-column :label="$t('other.a1116')">
          <template slot-scope="scope">
            <span>{{statusData[scope.row.auditStatus] }}</span>
          </template>
        </el-table-column>
    <el-table-column
      prop="description"
      :label="$t('other.a1117')">
      <template slot-scope="scope">
            <span>{{scope.row.description }}</span>
            <span style="color:#1890ff;cursor: pointer;margin-left:10px" @click="auditor(scope.row)">{{$t('other.a1095')}}</span>
          </template>
    </el-table-column>
  </el-table>
  <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="history = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="history = false">{{$t('other.a279')}}</el-button>
  </span> -->
</el-dialog>
    <el-dialog
  :title="$t('other.a1104')"
  :visible.sync="commbodystatus"
  width="30%"
  >
  <el-input v-model="commbody" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="commbodystatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="amendcomment">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a93')"
  :visible.sync="openCOST"
  width="30%"
  >
  <el-input v-model="costNum" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="openCOST = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="successCost">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
<!-- 图片预览   放在表格外面，这是个弹出狂-->
      <el-dialog :visible.sync="picturedi" :modal="false" :title="$t('other.a1118')" width="50%">
        <img :src="previewpic" alt=""  width="100%" />
        
       </el-dialog>
  <!-- 图片预览 -->

    <el-dialog
  :title="$t('other.a1105')"
  :visible.sync="particulars"
  width="85%"
  >
  <el-scrollbar
        wrapClass="scrollbar-wrap"
        style="height:450px"
        ref="scrollbarContainer">
     <el-table
      :data="purchaseOrderData"
      style="width: 100%">
      <el-table-column :label="$t('other.a1119')">
          <template slot-scope="scope" >
            <div class="pic_box">
              <el-image
              style="width: 200px; height: 100px;cursor: pointer;"
              :src="scope.row.userStoreItem.image"
              :fit="fit" @click="previewPic(scope.row.userStoreItem.image)"></el-image>
              <!-- <el-popover placement="top" title="" trigger="hover">
                <img
                  :src="scope.row.userStoreItem.image"
                  style="width: 200px; hright: 200px"
                />
                <img
                  slot="reference"
                  :src="scope.row.userStoreItem.image"
                  :alt="scope.row.userStoreItem.image"
                  style="max-height: 90px; max-width: 90px"
                />
              </el-popover> -->
              <!-- <img style="width: 120px;height:120px" :src="scope.row.userStoreItem.image" /> -->
            </div>
            
          </template>
        </el-table-column>
      <el-table-column :label="$t('other.a1120')" width="180">
            <template slot-scope="scope">
              <div class="order_time">SKU：{{ scope.row.userStoreItem.skuName }}</div>
              <div class="order_time">{{$t('other.a226')}}{{ scope.row.userStoreItem.cuscode }}</div>
              <div class="order_time">{{$t('other.a1166')}}：{{ scope.row.userStoreItem.storeName }}</div>
              <div class="order_time">{{$t('other.a799')}}：{{ scope.row.userStoreItem.userId }}</div>
              <div class="order_time">
                {{$t('other.a1167')}}(cm)：{{ scope.row.userStoreItem.packageLength }} x
                {{ scope.row.userStoreItem.packageLength }} x {{ scope.row.userStoreItem.packageHeight }}
              </div>
              <div class="order_time">{{$t('other.a1168')}}(kg)：{{ scope.row.userStoreItem.weight }}</div>
              <div>
                {{$t('other.a1169')}}：{{ scope.row.userStoreItem.address ? scope.row.userStoreItem.address : $t('other.a354') }}
              </div>
               <div>
                {{$t('other.a1170')}}：{{ scope.row.userStoreItem.price }}
              </div>
              <!-- <div class="order_time">产品尺码：{{ scope.row.productId }}</div>
            <div class="order_time">{{$t('other.a1168')}}(kg)：{{ scope.row.weight }}</div>
            <div class="order_time">供应商品号：{{ scope.row.productId }}</div>
            <div class="order_time">{{$t('other.a1261')}}：{{ scope.row.productId }}</div>
            <div class="order_time">产品销售人：{{ scope.row.userId }}</div>
            <div class="order_time">产品采购人：{{ scope.row.userId }}</div>
            <div class="order_time">产品开发人：{{ scope.row.userId }}</div> -->
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a1121')" width="180">
          <template slot-scope="scope">
            <div>
              {{$t('other.a1037')}}
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('other.a1122')"
                placement="top-start"
              >
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ：{{ scope.row.userStoreItem.stock }}
            </div>
            <div>
              {{$t('other.a1171')}}
              <el-tooltip
                class="item"
                effect="dark"
                :content="$t('other.a1123')"
                placement="top-start"
              >
                <i class="el-icon-question oook"></i>:
              </el-tooltip>
              ：{{ scope.row.userStoreItem.storeNum }}
            </div>
          </template>
        </el-table-column>
      <el-table-column
        prop="productId"
        :label="$t('other.a1124')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="amount"
        :label="$t('other.a1125')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="price"
        :label="$t('other.a1126')"
        width="100" >
        <template slot-scope="scope" >
              <div style="width: 80px">
                <span>{{ scope.row.price }}</span>
                <el-input
                @blur="scope.row.price=Number(scope.row.price)"
                  v-model="scope.row.price"
                  @input="onExchange(scope.$index)"
                  type="text"
                  v-if="vipLevel == 4"
                />

                <!-- <i  v-show="!scope.row.amountChecked"  class="el-icon-edit" @click="editClick(scope.$index, scope.row)"></i> -->
              </div>
            </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        :label="$t('other.a1127')"
        width="180">
        <template slot-scope="scope">
           <span>{{scope.row.remark}}</span>
           <span @click="editremark(scope.$index, scope.row)" style="color:#1890ff;cursor: pointer;margin-left:8px">{{$t('other.a93')}}</span>
          </template>
      </el-table-column>
      <el-table-column :label="$t('other.a33')">
          <template slot-scope="scope">
            <el-button size="mini" @click="modification(scope.$index, scope.row)"
              >{{$t('other.a1172')}}</el-button
            >
          </template>
        </el-table-column>
     
    </el-table>
    
  <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span style="font-size:16px;font-weight:bold">{{$t('other.a1173')}}</span>
     <span @click="editrsupplier" style="color:#1890ff;cursor: pointer;margin-left:8px">{{$t('other.a1100')}}</span>
    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
  </div>
  <div v-for="(item,index) in suppliersData" :key="index" class="text item">
    <div>{{$t('other.a1141')}}:{{item.supplier}}</div>
    <div>{{$t('other.a1133')}}:{{item.address}}</div>
    <div>{{$t('other.a1140')}}:{{item.paymentCycle}}{{$t('other.a177')}}</div>
    <div>{{$t('other.a56')}}:{{item.paymentMethod}}</div>
    <div>{{$t('other.a1134')}}:{{item.clearingFrom}}</div>
    <div>{{$t('other.a1138')}}:{{item.typeOfShipping}}</div>
  </div>
</el-card>
 
<el-card class="box-card">
  <div slot="header" class="clearfix">
    <span style="font-size:16px;font-weight:bold">{{$t('other.a1174')}}</span>
    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
  </div>
  <div class="text item">
    <div>{{$t('other.a1150')}}:{{formLabelAlign.createUserName}}</div>
    <div>{{$t('other.a1151')}}:{{formLabelAlign.buyerUserId}}</div>
    <div>{{$t('other.a1152')}}:{{formLabelAlign.buyerUserLeaderId}}</div>
    <!-- <div>头程费用:{{formLabelAlign.costOfFirstTransport}}</div> -->
    <div>{{$t('other.a1175')}}:{{formLabelAlign.netPurchaseOrder}} <span @click="editnote" style="color:#1890ff;cursor: pointer;">{{$t('other.a93')}}</span></div>
    <div>{{$t('other.a1176')}}:{{formLabelAlign.domesticWaybillNo}} <span @click="editwa" style="color:#1890ff;cursor: pointer;">{{$t('other.a93')}}</span></div>
    <!-- <div>仓库贴单费用:{{formLabelAlign.costOfWarehouseReceipt}}</div>
    <div>国内运输费用:{{formLabelAlign.costOfNativeTransport}}</div> -->
    <div>{{$t('other.a1177')}}:{{formLabelAlign.description}} <span @click="amendcost" style="color:#1890ff;cursor: pointer;">{{$t('other.a93')}}</span></div>
    <!-- <div>{{$t('other.a1152')}}:{{formLabelAlign.buyerUserLeaderId}}</div> -->
    <div v-if="formLabelAlign.isTransit==1">{{$t('other.a1131')}}:{{formLabelAlign.transitWarehouseBody ? formLabelAlign.transitWarehouseBody.warehouseName : $t('other.a354')}} <span @click="openHouse" style="color:#1890ff;cursor: pointer;">{{$t('other.a93')}}</span></div>
    <div v-if="vipLevel !=4">{{$t('other.a1143')}}:{{showStoreName(formLabelAlign.storeId)}}</div>
    <div>{{$t('other.a1178')}}:{{formLabelAlign.predictedArriveTime}}</div>
  </div>
</el-card>
 <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span style="font-size:16px;font-weight:bold">{{$t('other.a1179')}}</span>
    <!-- <span style="font-size:10px;margin-left:10px;color:#1890ff;cursor: pointer;" @click="addattribute">添加自定义属性</span> -->
    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
  </div>
  <div v-if="accessData.length==0">{{$t('other.a1180')}}</div>
  <div v-for="(ass,index) in accessData" :key="index" class="text item">
         <div style="margin:8px 0px">{{ass.attributeName}}:{{ass.attributeValue}}</div>
  </div>
</el-card>
  <el-card class="box-card">
  <div slot="header" class="clearfix">
    <span style="font-size:16px;font-weight:bold">{{$t('other.a1181')}}</span>
    <span style="font-size:10px;margin-left:10px;color:#1890ff;cursor: pointer;" @click="addcomment">{{$t('other.a1183')}}</span>
    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
  </div>
  <div v-if="comments.length==0">{{$t('other.a1182')}}</div>
  <div  class="text item" v-for="(con,index) in comments" :key="index">
      <div style="font-weight:400;margin:8px 0px">{{$t('other.a1184')}}：{{con.createUserId}} <span style="margin-left:20px">{{$t('other.a1185')}}：{{con.content}}</span> <span style="margin-left:20px">{{renderTime(con.createdTime)}}</span></div>
    
  </div>
</el-card>
</el-scrollbar>
<!-- <div>
  {{$t('other.a1177')}}:{{formLabelAlign.description}} <span @click="amendcost">{{$t('other.a93')}}</span>
</div> -->
<div class="auditbody">
  <div>
    <!-- <el-select v-model="auditType" placeholder="请选择要审核成的状态">
    <el-option
      v-for="item in auditTypeOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select> -->
  </div>
  <div v-show="additsta">
    <!-- <el-select v-model="auditType" placeholder="请选择要审核成的状态">
    <el-option
      v-for="item in auditTypeOptions"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select> -->
  <el-button type="danger" @click="auditcolse">{{$t('other.a1186')}}</el-button>
    <el-button type="primary" @click="openaudit">{{$t('other.a1187')}}</el-button>
    </div>
</div>

</el-dialog>
<el-dialog
  :title="$t('other.a1106')"
  :visible.sync="auditStatus"
  width="30%"
  >
  <el-select v-model="auditType" :placeholder="$t('other.a50')">
    <el-option
      v-for="item in auditTypeOptions"
      :key="item.values"
      :label="item.label"
      :value="item.values">
    </el-option>
  </el-select>
  <el-input v-model="inputStatus" :placeholder="$t('other.a1128')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="auditStatus = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="auditChange">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
<el-dialog
  :title="$t('other.a1107')"
  :visible.sync="modstause"
  width="30%"
  >
  <el-input v-model="modificationnum" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="modstause = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="amendnum">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
<el-dialog
  :title="$t('other.a1117')"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <el-input v-model="description" :placeholder="$t('other.a319')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="auditorder">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1129')"
  :visible.sync="depotadd"
  width="30%"
  >
  
   <el-input v-model="warehousesValue.warehouseName" :placeholder="$t('other.a1130')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="depotadd = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="depotsussced">{{$t('other.a279')}}</el-button>
  </span>
</el-dialog>
<el-dialog
  :title="$t('other.a1099')"
  :visible.sync="wareeaitor"
  width="30%"
  >
  
   <el-input v-model="warehousesValue.warehouseName" :placeholder="$t('other.a1130')"></el-input>
  <span slot="footer" class="dialog-footer">
    <el-button @click="wareeaitor = false">{{$t('other.a106')}}</el-button>
    <el-button type="primary" @click="waresucced">{{$t('other.a1188')}}</el-button>
  </span>
</el-dialog>
    <el-dialog
  :title="$t('other.a1131')"
  :visible.sync="depot"
  width="60%"
  >
   <el-button type="info" @click="waerhouseAdd">{{$t('other.a1189')}}</el-button>
   <el-table
      :data="depotData"
      style="width: 100%">
      <el-table-column
        prop="warehouseId"
        :label="$t('other.a1132')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="warehouseName"
        :label="$t('other.a533')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="createdTime"
        :label="$t('other.a57')">
        <template slot-scope="scope">
              <span>{{renderTime(scope.row.createdTime)}}</span>      
        </template>
      </el-table-column>
      <el-table-column :label="$t('other.a33')">
          <template slot-scope="scope">
            <el-button size="mini" @click="warehouseDeril(scope.$index, scope.row)"
              >{{$t('other.a93')}}</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deletewarehouse(scope.$index, scope.row)"
              >{{$t('other.a312')}}</el-button
            >
          </template>
        </el-table-column>
    </el-table>
  
</el-dialog>
    <el-dialog :title="$t('other.a1136')" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="sizeForm" label-width="120px" size="mini">
        <el-form-item :label="$t('other.a1133')">
          <el-input v-model="sizeForm.address" type="textarea"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1134')">
          <!-- <el-input v-model="sizeForm.clearingFrom"></el-input> -->
          <el-select
            v-model="sizeForm.clearingFrom"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in options"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('other.a1135')">
          <el-input v-model="sizeForm.paymentCycle"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1137')">
          <!-- <el-input v-model="formLabelAlign.paymentMethod" size="mini"></el-input> -->
          <el-select
            v-model="sizeForm.paymentMethod"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in options"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('other.a1113')">
          <el-input v-model="sizeForm.supplier"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1138')">
          <!-- <el-input v-model="sizeForm.typeOfShipping"></el-input> -->
            <el-select
            v-model="sizeForm.typeOfShipping"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in transportation"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="successAdd"
          >{{$t('other.a279')}}</el-button
        >
      </div>
    </el-dialog>
     <el-dialog :title="$t('other.a1139')" :visible.sync="dialogFormVisibleUP">
      <el-form ref="form" :model="sizeForm" label-width="120px" size="mini">
        <el-form-item :label="$t('other.a1133')">
          <el-input v-model="sizeForm.address" type="textarea"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1134')">
          <!-- <el-input v-model="sizeForm.clearingFrom"></el-input> -->
          <el-select
            v-model="sizeForm.clearingFrom"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in options"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('other.a1140')">
          <el-input v-model="sizeForm.paymentCycle"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1137')">
          <!-- <el-input v-model="formLabelAlign.paymentMethod" size="mini"></el-input> -->
          <el-select
            v-model="sizeForm.paymentMethod"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in options"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('other.a1113')">
          <el-input v-model="sizeForm.supplier"></el-input>
        </el-form-item>
        <el-form-item :label="$t('other.a1138')">
          <!-- <el-input v-model="sizeForm.typeOfShipping"></el-input> -->
            <el-select
            v-model="sizeForm.typeOfShipping"
            :placeholder="$t('other.a50')"
            size="mini"
          >
            <el-option
              v-for="item in transportation"
              :key="item.values"
              :label="item.label"
              :value="item.values"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleUP = false">{{$t('other.a106')}}</el-button>
        <el-button type="primary" @click="Supupdate"
          >{{$t('other.a1188')}}</el-button
        >
      </div>
    </el-dialog>
    <el-dialog :title="$t('other.a1113')" :visible.sync="dialogTableVisible" width="90%" >
  <el-table
      :data="gridData"
      border
      style="width: 100%">
      <el-table-column
        prop="address"
        :label="$t('other.a1133')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="clearingFrom"
        :label="$t('other.a1134')"
        width="180">
      </el-table-column>
      <el-table-column
        prop="createdTime"
        :label="$t('other.a57')">
        <template slot-scope="scope">{{renderTime(scope.row.createdTime) }}</template>
      </el-table-column>
       <el-table-column
        prop="paymentCycle"
        :label="$t('other.a1140')">
        <template slot-scope="scope">{{scope.row.paymentCycle }}{{$t('other.a177')}}</template>
      </el-table-column>
       <el-table-column
        prop="paymentMethod"
        :label="$t('other.a56')">
        <template slot-scope="scope">{{scope.row.paymentMethod }}</template>
      </el-table-column>
       <el-table-column
        prop="supplier"
        :label="$t('other.a1141')">
        <template slot-scope="scope">{{scope.row.supplier }}</template>
      </el-table-column>
      <el-table-column
        prop="typeOfShipping"
        :label="$t('other.a1138')">
        <template slot-scope="scope">{{scope.row.typeOfShipping }}</template>
      </el-table-column>
      <el-table-column :label="$t('other.a33')">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >{{$t('other.a1105')}}</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >{{$t('other.a312')}}</el-button
            >
          </template>
        </el-table-column>
    </el-table>
</el-dialog>
    <div class="title">{{$t('other.a1190')}} <el-button type="primary" icon="el-icon-refresh" circle size="mini" style="margin-left:4px" @click="refresh"></el-button></div>
    <div style="margin: 10px 13px 20px 0;" >
		    <span style="margin-right: 13px">{{$t("other.a866")}}：</span>
		    <el-date-picker
          size="mini"
		      v-model="value9"
		      type="daterange"
			    @change="getValue()"
			    value-format="yyyy-MM-dd"
		      :start-placeholder="$t('other.a45')"
		      :end-placeholder="$t('other.a46')"
		      >
		    </el-date-picker>
		</div>
    <div>
			<div style="margin:0 0 10px 0;display: flex;"  v-for="(item,index01) in buttonList" :key="index01">
				<div class="desc">{{item.desc}}</div>
				<span class="filterbox" >
					<span class="storeBox"  :class="{'ttpactive': activeIndex[index01] == ttp.label }" @click="handle(ttp.label,index01,index,ttp.value)"   v-for="(ttp,index) in item.value" :key="index">
						{{ttp.label}} 
					</span>
					
				</span>
			</div>
		</div>
    	
    <div class="title_body">
      <div style="width:77px;" >{{$t('other.a1191')}}:</div>
      <el-select size="mini" style="margin:0 6px;width:120px;" v-model="searchvalue" :placeholder="$t('other.a50')">
      <el-option
        style="width:150px;"
        size="mini"
        v-for="item in searchData"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
  </el-select>
      <el-input
        size="mini"
        style="width:350px;"
        :placeholder="$t('other.a1142')"
        v-model="ornumbers"
        clearable
        @input="inputvalue">
      </el-input>
       <el-button size="mini" type="primary" style="margin-left:8px" @click="searchorder" >{{$t('other.a27')}}</el-button>
      </div>
    <div class="btn_box"></div>
    <div class="pur_box">
      <div style="margin-bottom:15px;"  v-if="userPos === 'SELLER' && vipLevel !== 1">
        <el-button @click="toggleSelection" size="small" type="primary"
          >{{$t('other.a1192')}}</el-button
        >
        <el-button @click="createSupplier" size="small" type="primary"
          >{{$t('other.a1193')}}</el-button
        >
        <el-button @click="openList" size="small" type="primary"
          >{{$t('other.a1194')}}</el-button
        >
        <el-button @click="opentransit" size="small" type="primary"
          >{{$t('other.a1195')}}</el-button
        >
        <!-- {{$t('other.a1338')}}: <el-select v-model="screen" :placeholder="$t('other.a50')" @change="screencahnge">
    <el-option
      v-for="item in screenData"
      :key="item.values"
      :label="item.label"
      :value="item.values">
    </el-option>
  </el-select> -->
        <!-- <el-button @click="toggleSelection()">取消选择</el-button> -->
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        
        :default-sort="{ prop: 'date', order: 'descending' }"
        border
      >
        <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
        <!-- <el-table-column label="NO.">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('other.a1143')" v-if="vipLevel !=4">
          <template slot-scope="scope">
            <el-badge :value="$t('other.a1144')" class="item" v-if="scope.row.isPublicPurchase">
              
          </el-badge>
         
            <span>{{showStoreName(scope.row.storeId) }}</span>
          </template>
        </el-table-column>
         <el-table-column prop="purchaseOrderId" :label="$t('other.a1145')" width="120" >
          <template slot-scope="scope">
            <p v-if="scope.row.orderStatus == 'PURCHASING' && scope.row.isPublicPurchase"><el-badge :value="$t('other.a1146')" class="item"  >
                
            </el-badge>
            ({{scope.row.advanceRate}}%)
            </p>
              <p v-if="scope.row.isFinalPaid && scope.row.isPublicPurchase"><el-badge :value="$t('other.a1147')" class="item"  type="primary">
                
            </el-badge>
            ({{100 - scope.row.advanceRate}}%)
            </p>
         
            <span>{{scope.row.purchaseOrderId }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1149')" width="180" >
          <template slot-scope="scope">
             <el-badge :value="$t('other.a1148')" class="item" v-if="scope.row.isFromPlatform" type="warning">
              
          </el-badge>
            <div class="produ_cc">
                <div v-for="(item,index) in scope.row.purchaseOrderProducts"  :key="index" style="margin:4px;position: relative;"> 
                    <div v-show="index <scope.row.numType" >
                      <div v-if="item.userStoreItem == null">
                        {{$t('other.a1196')}}
                      </div>
                      <div v-if="item.userStoreItem">
                          <span class="pic-wrapper-quantity">{{item.amount}}</span>
                      
                            <el-popover placement="top" title="" trigger="hover">
                              <img
                                :src="item.userStoreItem.image"
                                style="width: 250px; hright: 250px"
                              />
                              <p>{{$t('other.a1125')}}：{{item.amount}}</p>
                              <p>W_SKU：{{item.userStoreItem.skuName}}</p>
                              <p>P_SKU：{{item.userStoreItem.itemSku}}</p>
                              <p>Cuscode：{{item.userStoreItem.cuscode}}</p>
                              <p>StoreName：{{item.userStoreItem.storeName}}</p>
                              
                                <img
                                slot="reference"
                                :src="item.userStoreItem.image"
                                :alt="item.userStoreItem.image"
                                style="max-height: 40px; max-width: 40px;border: 1px solid #d9d9d9;"
                              />
                              
                              
                              
                            </el-popover>
                      </div>
                        
                    </div>
                      
                  </div>
                    
                 
                  
              
           
            <div style="text-align:center;color:#409EFF;cursor: pointer;font-size:10px" v-show="scope.row.numType==6 &&  scope.row.purchaseOrderProducts.length > 6" @click="scope.row.numType = scope.row.purchaseOrderProducts.length"> 
                          {{$t('other.a1197')}} （{{$t('other.a1199')}}{{scope.row.purchaseOrderProducts.length-6}}{{$t('other.a1201')}}）
                      </div>
            <div style="text-align:center;color:#409EFF;cursor: pointer;font-size:10px" v-show="scope.row.numType!=6" @click="scope.row.numType = 6"> 
                          {{$t('other.a1198')}} （{{$t('other.a1200')}}{{scope.row.purchaseOrderProducts.length}}{{$t('other.a1201')}}）
                      </div>
            </div>
            
           
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a57')">
          <template slot-scope="scope">
            <span>{{renderTime(scope.row.createdTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createUserName"
          :label="$t('other.a1150')"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          prop="buyerUserName"
          :label="$t('other.a1151')"
          show-overflow-tooltip
        >
        </el-table-column>
        
        <el-table-column prop="buyerUserLeaderName" :label="$t('other.a1152')" show-overflow-tooltip>
        </el-table-column>
        <el-table-column :label="$t('other.a1153')">
          <template slot-scope="scope">
            <span>{{scope.row.isTransit==0?$t('other.a1157'):$t('other.a1158') }}</span>
            <!-- <span v-show="scope.row.isTransit==1">{{ scope.row.transitWarehouse }}</span> -->
          </template>
        </el-table-column>
        <!-- <el-table-column prop="costOfFirstTransport" :label="$t('other.a1534')"> </el-table-column>
        <el-table-column prop="costOfWarehouseReceipt" label="仓库贴单费用"> </el-table-column> -->
        <el-table-column :label="$t('other.a1154')">
          <template slot-scope="scope">
            <span>{{renderTime(scope.row.updatedTime) }}</span>
            <span style="font-size:10px;margin-left:10px;color:#1890ff;cursor: pointer;" @click="getorderStatus(scope.$index, scope.row)">{{$t('other.a1202')}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1155')"  width="120">
          <template slot-scope="scope">
            <div v-show="scope.row.orderStatus=='FIRST_AUDITING'">{{scope.row.orderStatus=='FIRST_AUDITING'?$t('other.a1159')+`${scope.row.buyerUserName}`+$t('other.a1160'): statusData[scope.row.orderStatus] ||scope.row.orderStatus=='SECOND_AUDITING'?$t('other.a1159')+`${scope.row.buyerUserLeaderName}`+$t('other.a1161'): statusData[scope.row.orderStatus] }} <i class="el-icon-edit" @click="editClick(scope.$index, scope.row)"></i></div>
            <div v-show="scope.row.orderStatus=='SECOND_AUDITING'">{{scope.row.orderStatus=='SECOND_AUDITING'?$t('other.a1159')+`${scope.row.buyerUserLeaderName}`+$t('other.a1161'): statusData[scope.row.orderStatus] }} <i class="el-icon-edit" @click="editClick(scope.$index, scope.row)"></i></div>
            <div v-show="scope.row.orderStatus!='SECOND_AUDITING'&&scope.row.orderStatus!='FIRST_AUDITING'&&scope.row.orderStatus!='FIRST_AUDIT_REJECTED'">{{statusData[scope.row.orderStatus] }} <i class="el-icon-edit" @click="editClick(scope.$index, scope.row)"></i></div>
            <div v-show="scope.row.orderStatus=='FIRST_AUDIT_REJECTED'">{{statusData[scope.row.orderStatus] }}</div>
            </template>
        </el-table-column>
        <el-table-column :label="$t('other.a1156')"  width="120">
          <template slot-scope="scope">{{ scope.row.description }}</template>
        </el-table-column>
        <!-- <el-table-column :label="$t('other.a56')"  width="120">
          <template slot-scope="scope">{{ scope.row.paymentMethod }}</template>
        </el-table-column> -->
        <el-table-column :label="$t('other.a33')">
          <template slot-scope="scope">
            <el-button size="mini" @click="orderDetail(scope.$index, scope.row)"
              >{{$t('other.a600')}}</el-button
            >
            <el-button size="mini" style="margin:10px" type="warning" @click="orderDeril(scope.$index, scope.row)" v-show="scope.row.isFinalPaid != true"
              >{{$t('other.a1203')}}</el-button
            >
            <!-- <el-button size="mini" @click="orderDeril(scope.$index, scope.row)"
              >{{$t('other.a1105')}}</el-button
            > -->
            <el-button
              size="mini"
              style="margin:10px"
              type="danger"
              v-if="userPos === 'SELLER' && vipLevel !== 1"
              @click="deletePur(scope.$index, scope.row)"
              
              >{{$t('other.a312')}}</el-button
            >
            <el-button
              size="mini"
              type="primary"
              v-if="userPos === 'SELLER' && vipLevel !== 1 && scope.row.isPublicPurchase && scope.row.isFinalPaid == null && scope.row.orderStatus == 'PURCHASING'"
              @click="outproduct(scope.$index, scope.row)"
              
              >{{$t('other.a1204')}}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
    
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[50,100,150,200]"
      :page-size="pagesize4"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tatal">
    </el-pagination>
  </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import purchase from "../../api/api";
import utils from '../../utils/utils.js'
import group from '../../api/moudles/group.js'
import buyer from "../../api/moudles/account"

export default {
  data() {
    return {
      outstatus:false,
      labelPosition: 'right',
        publicdata: {
          advanceRate: 30,
          paymentDeadline: 30,
          totalAmount: 0
        },
      publicS:false,
      publicD:false,
      numType:6,
      purchaseList:[],
      activeIndex:[this.$t('other.a358'),this.$t('other.a358'),this.$t('other.a358'),this.$t('other.a358')],
      buttonList:[],//筛选条件
      value9: [],
      searchData: [{
          value: 'purchaseOrderId',
          label: this.$t('other.a1205')
        },
        {
          value: 'productName',
          label: this.$t('other.a817')
        },
        {
          value: 'domesticWaybillNo',
          label: this.$t('other.a1176')
        },
        {
          value: 'productSku',
          label: this.$t('other.a1206')
        }],
        searchvalue: 'purchaseOrderId',
      updateStatus:false,
      updateValue:null,
      fit:'fill',
      picturedi: false,
        previewpic: "",
      ornumbers:null,
      additsta:true,
      noteValue:null,
      noteStatus:false,
      propertystatus:false,
      transit:null,
      transitStatus:false,
      remarkValue:null,
      remarkStatus:false,
      waybillnumber:null,
      waybillStatus:false,
      tatal:null,
      currentPage4:1,
      pagesize4:50,
      history:false,
      historyData:[],
      vipLevel:JSON.parse(localStorage.getItem("userInfo")).vipLevel,
      userPos:JSON.parse(localStorage.getItem("userInfo")).userPos,
      accessData:[],
      commbody:null,
      commbodystatus:false,
      statusData:{
        "FIRST_AUDIT_REJECTED":this.$t('other.a1208'),
        "FIRST_AUDITING":this.$t('other.a1209'),
        "SECOND_AUDITING":this.$t('other.a1210'),
        "PURCHASING":this.$t('other.a1211'),
        "BEFORE_TRANSFERING":this.$t('other.a1212'),
        "TRANSFERING":this.$t('other.a1213'),
        "BEFORE_ARRIVED":this.$t('other.a1214'),
        "IN_WAREHOUSE":this.$t('other.a1215'),
        "COMPLETED":this.$t('other.a119'),
        "CLOSED":this.$t('other.a120'),
        "RECEIVED_BY_STOCK":this.$t('other.a1216')
      },
      costNum:null,
      openCOST:false,
      purchaseOrderIdAU :null,
      auditStatus:false,
      screen:'',
      screenData:[
        {
          values: "",
          label: this.$t('other.a1207'),
        },
         {
          values: "FIRST_AUDIT_REJECTED",
          label: this.$t('other.a1208'),
        },
        {
          values: "FIRST_AUDITING",
          label: this.$t('other.a1209'),
        },
        {
          values: "SECOND_AUDITING",
          label: this.$t('other.a1210'),
        },
        {
          values: "PURCHASING",
          label: this.$t('other.a1211'),
        },
        
        {
          values: "BEFORE_TRANSFERING",
          label: this.$t('other.a1212'),
        },
        {
          values: "TRANSFERING",
          label: this.$t('other.a1213'),
        },
        {
          values: "BEFORE_ARRIVED",
          label: this.$t('other.a1214'),
        },
        {
          values: "IN_WAREHOUSE",
          label: this.$t('other.a1215'),
        },
        {
          values: "COMPLETED",
          label: this.$t('other.a119'),
        },
        {
          values: "RECEIVED_BY_STOCK",
          label: this.$t('other.a1216'),
        },
        {
          values: "CLOSED",
          label: this.$t('other.a120'),
        }
        
      ],
      auditTypeOptions:[
        {
          values: "PURCHASING",
          label: this.$t('other.a1211'),
        },
        
        {
          values: "BEFORE_TRANSFERING",
          label: this.$t('other.a1212'),
        },
        {
          values: "TRANSFERING",
          label: this.$t('other.a1213'),
        },
        {
          values: "BEFORE_ARRIVED",
          label: this.$t('other.a1214'),
        },
        {
          values: "IN_WAREHOUSE",
          label: this.$t('other.a1215'),
        },
        {
          values: "COMPLETED",
          label: this.$t('other.a119'),
        },
        {
          values: "CLOSED",
          label: this.$t('other.a120'),
        }
      ],
      modstause:false,
      modificationnum:null,
      description:null,
      dialogVisible:false,
      formLabelAlign:{
        buyerUserId: "",
        buyerUserLeaderId: "",
        costOfFirstTransport: "",
        costOfWarehouseReceipt: "",
        createUserId: JSON.parse(localStorage.getItem("userInfo")).userId,
        createdTime: "2021-09-06T04:16:11.798Z",
        description: "",
        firstAuditTime: "2021-09-06T04:16:11.798Z",
        isTransit: 0,
        netPurchaseOrder: "",
        orderStatus: "FIRST_AUDITING",
        paymentMethod: "",
        predictedArriveTime: "2021-09-06T04:16:11.798Z",
        purchaseOrderId: "string",
        purchaseOrderProducts: [
          {
            amount: 0,
            createdTime: "2021-09-06T04:16:11.798Z",
            id: "string",
            orderId: "string",
            productId: "",
            productSkuId: "",
            updatedTime: "2021-09-06T04:16:11.798Z",
          },
        ],
        rejectReason: "string",
        secondAuditTime: "2021-09-06T04:16:11.798Z",
        supplier: "",
        timeLimitOfFirstTransport: "string",
        transitWarehouse: "",
        updatedTime: "2021-09-06T04:16:11.798Z",
      },
      particulars:false,
      purchaseCount:null,
      wareeaitor:false,
      depot:false,
      depotadd:false,
      depotData:[],
      dialogFormVisibleUP:false,
      dialogTableVisible:false,
      gridData:[],
      transportation: [
        {
          values: this.$t('other.a1217'),
          label: this.$t('other.a1217'),
        },
        {
          values: this.$t('other.a1218'),
          label: this.$t('other.a1218'),
        },
        {
          values: this.$t('other.a1219'),
          label: this.$t('other.a1219'),
        },
      ],
      options: [
        {
          values: this.$t('other.a1220'),
          label: this.$t('other.a1220'),
        },
        {
          values: this.$t('other.a1221'),
          label: this.$t('other.a1221'),
        },
        {
          values: this.$t('other.a1222'),
          label: this.$t('other.a1222'),
        },
      ],
      
      sizeForm: {
        address: "",
        clearingFrom: "",
        paymentCycle: "",
        paymentMethod: "",
        supplier: "",
        typeOfShipping: "",
        createdTime:"2021-09-03T02:05:39.002Z",
        id: "string",
        productId: "string",
        userId: JSON.parse(localStorage.getItem("userInfo")).userId,
        updatedTime:"2021-09-03T02:05:39.002Z",
      },
      dialogFormVisible: false,
      userId: JSON.parse(localStorage.getItem("userInfo")).userId,
      btnlist: [],
      tableData: [
        
      ],
      multipleSelection: [],
      warehousesValue:{
          createUserId: JSON.parse(localStorage.getItem("userInfo")).userId,
          createdTime: "2021-09-06T03:26:49.136Z",
          udpatedTime: "2021-09-06T03:26:49.136Z",
          warehouseId: "string",
          warehouseName: ""
        },
      purchaseOrderData:[],
      suppliersData:[],
      indexfor:null,
      auditType:null,
      inputStatus:'',
      comments:[],
      tablesValue:[],
      supplierStatus:false,
      supplierValue:null,
      formInline: {
          user: '',
          region: ''
        },
      comment:null,
      dataOrder:{
          domesticWaybillNo: "",
          endTime: "",
          initiator: "",
          isSeller: true,
          orderStatus: "",
          pageNum: 1,
          pageSize: 50,
          productName: "",
          productSku:"",
          purchaseOrderId: "",
          purchaser: "",
          startTime: "",
          storeId: 0,
          userId: JSON.parse(localStorage.getItem("userInfo")).userId
        },
        groupsData:[],
        sellerId:null,
        searchsData:{
                 pageNum:1,
                 pageSize:50,
                 partnerId:0,
                 userId:"systemAdmin"
             },
        PublicList:[],
        flag:false,
        
    };
  },
  created() {
    if(JSON.parse(localStorage.getItem("userInfo")).vipLevel == 1){
      this.sellerId = JSON.parse(localStorage.getItem("userInfo")).sellerId
    }else if(JSON.parse(localStorage.getItem("userInfo")).vipLevel == 0){
      this.sellerId = JSON.parse(localStorage.getItem("userInfo")).userId
      this.getBuyer();
    }else if(JSON.parse(localStorage.getItem("userInfo")).vipLevel == 4){
      this.sellerId = JSON.parse(localStorage.getItem("userInfo")).userId
    }
    this.getPurchaseLisr();
    this.getUserSuplist();
    // this.getUserpurchase();

    this.getUserHouse();
    this.init();
    this.getGroups();
    this.getAll();
    // this.getBuyer();
  },
  mounted(){
    // setTimeout(() => {
    //   this.getBtn();  
      
    // }, 1000);
    
  },
  watch:{
    flag(){
        if(this.flag == true){
            this.getBtn();  
        }
    },
  },
  computed:{
			
			
			dateInfo(){
				let list=JSON.parse(JSON.stringify(this.value9))
				list[1]=utils.CurdateAddoneday(list[1])
				return list
			}
			
			
			
		
		},
  methods: {
    outproduct(index,row){
      this.paypcoid = row.purchaseOrderId
      this.outstatus = true
    },
    payout(){
      purchase
        .paymentorder({
          purchaseId : this.paypcoid
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.$message.success(this.$t('other.a1223'));
           this.getUserpurchase();
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },
    onExchange(index) {
      let moment = this.purchaseOrderData[index]; // 此处的tableData为自己的table表格绑定的data数组
      this.$set(this.purchaseOrderData, index, moment);
      // 此处是将修改的那一行的数据重新赋值给table表格对应的那一行，触发热更新。
      console.log(this.purchaseOrderData)
    },
    publicDsucceed(){
      this.publicD = false
      this.dialogVisible = true
    },
    publicSsucceed(){
      this.formLabelAlign.advanceRate = this.publicdata.advanceRate
      this.formLabelAlign.paymentDeadline = this.publicdata.paymentDeadline
      // this.formLabelAlign.totalAmount = this.publicdata.totalAmount
      purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.publicS = false
              // this.$message.success(this.$t('other.a665'));
             this.dialogVisible = true
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//添加收款比例等信息
    showusername(id){
      let stores=this.PublicList
		let ttp=null
		if(stores){
			stores.forEach(p => {
				if(p.userId == id){
					ttp=true
				}else{
          ttp=false
        }
			})
		}

		return ttp ? ttp : this.$t("other.a354")
    },//看点击审核的是否为公共采购员
    getAll(){
            purchase
				  .getpuser(this.searchsData)
				  .then(res => {
					 if(res.code === 200){
                       this.PublicList = res.data.list
                        // this.tableData = res.data.list
                     }else{
                         this.$message.warning(res.msg);
                     }
					  
					  
					 
					 console.log(res);
					
                  })
        },
    tableRowClassName({row, rowIndex}) {
        if (row.isPublicPurchase) {
          return 'success-row';
        } else{
          return '';
        }
        return '';
      },
    getBuyer(){
        buyer
        .getBuyer({
          userId:this.sellerId
        })
        .then((res) => {
          console.log(res);
          if(res.code == 200){
            let arrnew = res.data.map((item, index) => {
                    return Object.assign(
                      {},
                      {
                        value : item.userId,
                        label : item.userName
                      }
                    );
                  });
              
              this.purchaseList = arrnew;
             console.log(this.purchaseList)
          }else{
            this.$message.warning(res.msg);
          }
         
        });
    },
    getGroups(){
      let obj = {
        months :1,
        quarters:1,
        timeType:1,
        userId　: this.sellerId,
        years:2021
      }
        group
        .getUserGroup(obj)
        .then((res) => {
          // console.log(res);
          if(res.code =='200'){
             let arrnew = res.data.map((item, index) => {
                    return Object.assign(
                      {},
                      {
                        value : item.groupId,
                        label : item.name
                      }
                    );
                  });
              console.log(arrnew)
              this.groupsData = arrnew;
             this.flag = true
              
          }else{
            this.$message.warning(res.msg);
          }
          });
         
    },//获取用户的运营小组
    handle(key,index,indexone,value){
				console.log(key,index,indexone,value)
        this.$set(this.activeIndex,index,key)
        if(index == 1){
          if(value == 'all'){
            this.dataOrder.storeId = 0;
            this.getUserpurchase();
          }else{
            this.dataOrder.storeId = value
          this.getUserpurchase();
          }
          

        }else if(index == 0){
          if(value == 'all'){
            this.dataOrder.initiator = '';
            this.getUserpurchase();
          }else{
            this.dataOrder.initiator = key
          this.getUserpurchase();
          }
        }else if(index == 2){
          if(value == 'all'){
            this.dataOrder.purchaser = '';
            this.getUserpurchase();
          }else{
            this.dataOrder.purchaser = key
          this.getUserpurchase();
          }

        }else if(index == 3){
          if(value == 'all'){
            this.dataOrder.orderStatus = '';
            this.getUserpurchase();
          }else{
            this.dataOrder.orderStatus = value
          this.getUserpurchase();
          }
        }
        },
    	getBtn(){
        
				this.buttonList=[{
					id:0,
					desc:this.$t('other.a1224'),
					value:this.groupsData
				},{
					id:0,
					desc:this.$t('other.a248'),
					value:utils.getStore()
				},{
					id:2,
					desc:this.$t('other.a1225'),
					value:this.purchaseList
				},{
          id:3,
          desc:this.$t('other.a1226'),
          value:[
              {
                value: "FIRST_AUDITING",
                label: this.$t('other.a1209'),
              },
              {
                value: "SECOND_AUDITING",
                label: this.$t('other.a1210'),
              },
              {
                value: "FIRST_AUDIT_REJECTED",
                label: this.$t('other.a1208'),
              },
              {
                value: "PURCHASING",
                label: this.$t('other.a1211'),
              },
              
              {
                value: "BEFORE_TRANSFERING",
                label: this.$t('other.a1212'),
              },
              {
                value: "TRANSFERING",
                label: this.$t('other.a1213'),
              },
              {
                value: "BEFORE_ARRIVED",
                label: this.$t('other.a1214'),
              },
              {
                value: "IN_WAREHOUSE",
                label: this.$t('other.a1215'),
              },
              {
                value: "COMPLETED",
                label: this.$t('other.a119'),
              },
              {
                value: "CLOSED",
                label: this.$t('other.a120'),
              }
            ],
        }
				]
				
				this.buttonList.forEach(p => {
					p.value.unshift({
						label:this.$t('other.a358'),
						value:'all'
					})
				})

				
				
				console.log('btn',this.buttonList)
			},
    getValue(){
      if(this.value9 == null){
        this.dataOrder.endTime=''
        this.dataOrder.startTime=''
        this.getUserpurchase();
      }else{
        console.log(this.dateInfo)
				this.dataOrder.endTime=this.dateInfo[1]
				this.dataOrder.startTime=this.dateInfo[0]
				this.getUserpurchase();
      }
				
				
				
			},
    init(){
				this.value9=[utils.getRecentSevenDay(-60),utils.getRecentSevenDay(1)]
				this.dataOrder.endTime=this.dateInfo[1]
				this.dataOrder.startTime=this.dateInfo[0]
				this.getUserpurchase();
				
				
			},
    inputvalue(){
      if(this.ornumbers == ''){
        this.dataOrder.purchaseOrderId = '';
        // this.dataOrder.initiator = '';
        this.dataOrder.productName = '';
        this.dataOrder.productSku = '';
        this.getUserpurchase();
      }
    },
    searchorder(){
      
      if(this.searchvalue == 'purchaseOrderId'){
        this.dataOrder.purchaseOrderId = this.ornumbers
        this.getUserpurchase();
      }else if(this.searchvalue == 'domesticWaybillNo'){
        this.dataOrder.domesticWaybillNo = this.ornumbers
        this.getUserpurchase();
      }else if(this.searchvalue == 'productName'){
        this.dataOrder.productName = this.ornumbers
        this.getUserpurchase();
      }else if(this.searchvalue == 'productSku'){
        this.dataOrder.productSku = this.ornumbers
        this.getUserpurchase();
      }
      
      
      // purchase
      //   .searchorders(obj)
      //   .then((res) => {
      //     console.log(res);
      //     if(res.code =='ok'){
      //       this.tableData = res.result.purchaseOrders
            
      //       // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              
      //     }else{
      //       this.$message.warning(res.msg);
      //     }
          
      //   });
    },//按订单号进行筛选
    updatesucced(){
      console.log(this.comment)
      this.comment.description = this.updateValue
      purchase
        .auditupdate(this.comment)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              this.$message.success(this.$t('other.a665'));
              this.updateStatus = false
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },
    auditor(order){
      console.log(order)
      this.comment = order;
      this.updateStatus = true
      this.updateValue = order.description
    },
    //预览大图
       previewPic(url) {
           this.previewpic = url;
           this.picturedi = true;
        },
    showStoreName(id){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
		let ttp=null
		if(stores){
			stores.forEach(p => {
				if(p.storeId == id){
					ttp=p.storeName
				}
			})
		}

		return ttp ? ttp : this.$t("other.a354")
	},
    noteSussed(){
      console.log(this.noteValue);
      this.formLabelAlign.netPurchaseOrder = this.noteValue;
      let arrnew = this.formLabelAlign.purchaseOrderProducts.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: item.amount,
            createdTime: "",
            id: item.id,
            orderId: item.orderId,
            remark:item.remark,
            productId: item.productId,
            productSkuId: item.productSkuId,
            updatedTime: "",
          }
        );
      });
       this.formLabelAlign.createdTime = "";
      this.formLabelAlign.firstAuditTime = "";
      this.formLabelAlign.predictedArriveTime = "";
      this.formLabelAlign.secondAuditTime = "";
      this.formLabelAlign.updatedTime = "";
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
      
       purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              this.$message.success(this.$t('other.a665'));
             this.noteValue = '';
             this.noteStatus = false;
              // this.particulars = false;
              this.getUserpurchase();
              this.getDetail(this.formLabelAlign.purchaseOrderId);
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//修改网采购单
    editnote(){
      this.noteStatus = true;
      this.noteValue = this.formLabelAlign.netPurchaseOrder
    },
      addattribute(){
      this.propertystatus = true;
    },//
     propertyadd(){
      // console.log(this.formInline);
      let obj ={
            purchaseOrderAttributes:[
              {
                attributeId: "string",
                attributeName: this.formInline.user,
                attributeValue: this.formInline.region,
                createdTime: "2021-09-08T04:07:48.421Z",
                purchaseOrderId: this.formLabelAlign.purchaseOrderId,
                updatedTime: "2021-09-08T04:07:48.421Z"
              }
            ],
            purchaseOrderId : this.formLabelAlign.purchaseOrderId,
      }
     console.log(obj);
     purchase
        .createattri(obj)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              this.$message.success(this.$t('other.a1227'));
              this.propertystatus = false;
              this.getUserpurchase();
              this.getattribute(this.formLabelAlign.purchaseOrderId);
              this.getDetail(this.formLabelAlign.purchaseOrderId);
          }else{
            this.$message.warning(res.msg);
          }
          
        });
      // this.propertystatus = false
    },//添加自定义属性
    transitsuss(){
      console.log(this.transit)
      this.formLabelAlign.transitWarehouse = this.transit;
      let arrnew = this.formLabelAlign.purchaseOrderProducts.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: item.amount,
            createdTime: "",
            id: item.id,
            orderId: item.orderId,
            remark:item.remark,
            productId: item.productId,
            productSkuId: item.productSkuId,
            updatedTime: "",
          }
        );
      });
       this.formLabelAlign.createdTime = "";
      this.formLabelAlign.firstAuditTime = "";
      this.formLabelAlign.predictedArriveTime = "";
      this.formLabelAlign.secondAuditTime = "";
      this.formLabelAlign.updatedTime = "";
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
      
       purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              this.$message.success(this.$t('other.a665'));
             this.transit = '';
             this.transitStatus = false;
              // this.particulars = false;
              this.getUserpurchase();
              this.getDetail(this.formLabelAlign.purchaseOrderId);
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//修改中转仓
    openHouse(){
      this.transitStatus = true;
      this.transit = this.formLabelAlign.transitWarehouse;
    },//
    suppliersucced(){
      console.log(this.supplierValue);
      this.formLabelAlign.supplier=this.supplierValue;
      let arrnew = this.formLabelAlign.purchaseOrderProducts.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: item.amount,
            createdTime: "",
            id: item.id,
            orderId: item.orderId,
            remark:item.remark,
            productId: item.productId,
            productSkuId: item.productSkuId,
            updatedTime: "",
          }
        );
      });
       this.formLabelAlign.createdTime = "";
      this.formLabelAlign.firstAuditTime = "";
      this.formLabelAlign.predictedArriveTime = "";
      this.formLabelAlign.secondAuditTime = "";
      this.formLabelAlign.updatedTime = "";
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
      
       purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              this.$message.success(this.$t('other.a665'));
              this.supplierValue = '';
               this.supplierStatus = false;
              // this.particulars = false;
              this.getUserpurchase();
              this.getDetail(this.formLabelAlign.purchaseOrderId);
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//修改供应商
    editrsupplier(){
      this.supplierValue = this.formLabelAlign.supplier;
      this.supplierStatus = true;
    },//修改供应商
    refresh(){
        this.getUserpurchase();
        this.$message.success(this.$t('other.a1228'));
    },//刷新采购单
    remarksucced(){
      this.formLabelAlign.purchaseOrderProducts[this.indexfor].remark=this.remarkValue;
      let arrnew = this.formLabelAlign.purchaseOrderProducts.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: item.amount,
            createdTime: "",
            id: item.id,
            orderId: item.orderId,
            remark:item.remark,
            productId: item.productId,
            productSkuId: item.productSkuId,
            updatedTime: "",
          }
        );
      });
       this.formLabelAlign.createdTime = "";
      this.formLabelAlign.firstAuditTime = "";
      this.formLabelAlign.predictedArriveTime = "";
      this.formLabelAlign.secondAuditTime = "";
      this.formLabelAlign.updatedTime = "";
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
      
       purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              this.$message.success(this.$t('other.a665'));
              this.remarkValue = '';
              this.remarkStatus = false;
              // this.particulars = false;
              this.getUserpurchase();
              this.getDetail(this.formLabelAlign.purchaseOrderId);
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//修改采购商品备注
     handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.dataOrder.pageSize = val;
        this.getUserpurchase();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.dataOrder.pageNum = val;
        this.getUserpurchase();
      },
    getorderStatus(index,rows){
      console.log(rows.purchaseOrderId);
      purchase
        .getaudit({
          
          purchaseOrderId :rows.purchaseOrderId
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.history = true;
              this.historyData = res.purchaseOrderAudits;
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//查看状态变更历史
    screencahnge(){
      this.dataOrder.orderStatus = this.screen;
       this.getUserpurchase();
      // console.log(this.screen);
      // this.groupleader = res.data.filter(function(item,index,array){
      //             //元素值，元素的索引，原数组。
      //             return (item.isSellerPurchaseLeader==1);
      //         });
      // if(this.screen == 'ALL'){
      //     this.getUserpurchase();
      // }else{
      // //     let newarr = this.tablesValue.filter((item,index,array)=>{
      // //             //元素值，元素的索引，原数组。
      // //             return (item.orderStatus==this.screen);
      // //         });
      // // this.tableData = newarr;
      // }
      
      // console.log(newarr);
    },
    amendcomment(){
      purchase
        .createcomment({
          commentUserId : this.userId,
          content : this.commbody,
          purchaseOrderId :this.formLabelAlign.purchaseOrderId
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.$message.success(this.$t('other.a1227'));
             this.commbodystatus = false;
             this.getCommentData(this.formLabelAlign.purchaseOrderId)
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//添加评论
    addcomment(){
      this.commbodystatus = true
    },//打开评论弹窗
    successCost(){
      this.formLabelAlign.description =this.costNum;
      let arrnew = this.formLabelAlign.purchaseOrderProducts.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: item.amount,
            createdTime: "",
            id: item.id,
            remark:item.remark,
            orderId: item.orderId,
            productId: item.productId,
            productSkuId: item.productSkuId,
            updatedTime: "",
          }
        );
      });
      
      this.formLabelAlign.createdTime = "";
      this.formLabelAlign.firstAuditTime = "";
      this.formLabelAlign.predictedArriveTime = "";
      this.formLabelAlign.secondAuditTime = "";
      this.formLabelAlign.updatedTime = "";
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
        purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            
              this.$message.success(this.$t('other.a665'));
             this.openCOST = false;
              this.modstause = false;
              // this.particulars = false;
              this.getDetail(this.formLabelAlign.purchaseOrderId);
              this.getUserpurchase();
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },
    amendcost(){
      this.openCOST = true;
      this.costNum = this.formLabelAlign.description;
    },
    editwa(){
      this.waybillStatus = true;
      this.waybillnumber= this.formLabelAlign.domesticWaybillNo
    },
    editremark(index,rows){
      this.remarkStatus = true;
      this.indexfor = index;
      this.remarkValue = this.formLabelAlign.purchaseOrderProducts[this.indexfor].remark;
    },
    modification(index,rows){
      console.log(index)
      console.log(rows)
      this.indexfor = index;
      this.modificationnum = this.formLabelAlign.purchaseOrderProducts[this.indexfor].amount;
      this.modstause = true
    },
    waybillSucces(){
      this.formLabelAlign.domesticWaybillNo =this.waybillnumber;
      let arrnew = this.formLabelAlign.purchaseOrderProducts.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: item.amount,
            createdTime: "",
            id: item.id,
            remark:item.remark,
            orderId: item.orderId,
            productId: item.productId,
            productSkuId: item.productSkuId,
            updatedTime: "",
          }
        );
      });
      
      this.formLabelAlign.createdTime = "";
      this.formLabelAlign.firstAuditTime = "";
      this.formLabelAlign.predictedArriveTime = "";
      this.formLabelAlign.secondAuditTime = "";
      this.formLabelAlign.updatedTime = "";
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
        purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            
              this.$message.success(this.$t('other.a665'));
             this.waybillStatus = false;
              // this.particulars = false;
              this.getDetail(this.formLabelAlign.purchaseOrderId);
              this.getUserpurchase();
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },
    openaudit(){
      console.log(this.formLabelAlign)
       
       if(this.formLabelAlign.isPublicPurchase){
         if(this.showusername(this.userId) == true){
           this.formLabelAlign.purchaseOrderProducts.forEach(p=>{
             if( p.price == 0){
               this.$message.warning(this.$t('other.a1229'));
               
             }else{
               purchase
              .updatepurchase(this.formLabelAlign)
              .then((res) => {
                console.log(res);
                if(res.code =='ok'){
                    this.particulars = false;
                    this.publicS = true
                    
                    
                }else{
                  this.$message.warning(res.msg);
                }
                
              });
             }
            
           })
           
              
           console.log('公共采购员点击')
           
         }else{
           purchase
              .updatepurchase(this.formLabelAlign)
              .then((res) => {
                console.log(res);
                if(res.code =='ok'){
                    this.particulars = false;
                    this.publicD = true
                    this.getDetail(this.formLabelAlign.purchaseOrderId);
                    
                }else{
                  this.$message.warning(res.msg);
                }
                
              });
          //  this.particulars = false;
          //  this.publicD = true
           console.log('卖家点击')
         }
        //  console.log(this.showusername(this.formLabelAlign.buyerUserId))
       }else{
         this.particulars = false;
          this.dialogVisible = true;
       }
     
    },
    auditcolse(){
        purchase
        .auditpurchase({
            auditType : "FIRST_AUDIT_REJECTED",
            description : this.description ,
            purchaseOrderId :this.formLabelAlign.purchaseOrderId,
            userId : this.userId
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.$message.success(this.$t('other.a1230'));
              // this.dialogVisible = false;
              this.description = '';
              this.particulars = false;
              this.getUserpurchase();
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//不通过审核
    amendnum(){
      // this.formLabelAlign.
      console.log(this.formLabelAlign.purchaseOrderProducts[this.indexfor].amount)
      this.formLabelAlign.purchaseOrderProducts[this.indexfor].amount=parseInt(this.modificationnum);
      let arrnew = this.formLabelAlign.purchaseOrderProducts.map((item, index) => {
        return Object.assign(
          {},
          {
            amount: item.amount,
            createdTime: "",
            id: item.id,
            orderId: item.orderId,
            remark:item.remark,
            productId: item.productId,
            productSkuId: item.productSkuId,
            updatedTime: "",
          }
        );
      });
       this.formLabelAlign.createdTime = "";
      this.formLabelAlign.firstAuditTime = "";
      this.formLabelAlign.predictedArriveTime = "";
      this.formLabelAlign.secondAuditTime = "";
      this.formLabelAlign.updatedTime = "";
      this.formLabelAlign.purchaseOrderProducts = arrnew;
      console.log(this.formLabelAlign);
      
       purchase
        .updatepurchase(this.formLabelAlign)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            // Vue.set(this.formLabelAlign.purchaseOrderProducts[this.indexfor],'amount',parseInt(this.modificationnum))
              this.$message.success(this.$t('other.a665'));
              this.modificationnum = '';
              this.modstause = false;
              // this.particulars = false;
              this.getUserpurchase();
              this.getDetail(this.formLabelAlign.purchaseOrderId);
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },
    auditorder(){
      console.log(this.formLabelAlign.orderStatus);
      
        purchase
        .auditpurchase({
            auditType : this.formLabelAlign.orderStatus,
            description : this.description ,
            purchaseOrderId :this.formLabelAlign.purchaseOrderId,
            userId : this.userId
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.$message.success(this.$t('other.a684'));
              this.dialogVisible = false;
              this.description = '';
              // this.particulars = false;
              this.getUserpurchase();
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//审核采购单
    waresucced(){
      purchase
        .updatewarehouse(this.warehousesValue)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.$message.success(this.$t('other.a1231'));
              this.getUserHouse();
              this.wareeaitor = false;
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },//更新仓库信息
    warehouseDeril(index,rows){
      console.log(rows);
      this.wareeaitor = true;
      this.warehousesValue = rows;
    },
    deletewarehouse(index,rows){
      console.log(rows)
      purchase
        .deleteware({
          warehouseId : rows.warehouseId
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.$message.success(this.$t('other.a1232'));
              this.getUserHouse();
          }else{
            this.$message.warning(res.msg);
          }
          
        });
    },
    depotsussced(){
        purchase
        .createware(this.warehousesValue)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.$message.success(this.$t('other.a1227'));
              this.getUserHouse();
          }else{
            this.$message.warning(res.msg);
          }
          this.depotadd = false;
        });
    },//新增中转仓
    waerhouseAdd(){
      this.depotadd = true
    },//
    getUserpurchase(){
      purchase
        .searchorders(this.dataOrder)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            if(res.result.purchaseOrders != ''){
              res.result.purchaseOrders.forEach(p=>{
              p.numType = 6
            })
            }
            
              
              if(res.result.purchaseOrders != null){
                this.tableData = res.result.purchaseOrders
                this.tablesValue=res.result.purchaseOrders
              }else{
                 this.tableData = []
                this.tablesValue=[]
              }
              console.log(this.tableData);
              if(res.result.pageInfo !=null){
                this.tatal = res.result.pageInfo.total
                this.purchaseCount = res.result.pageInfo.total
              }else{
                this.tatal = 0
                this.purchaseCount = 0
              }
              
              
              
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//获取用户的所有采购单
    getUserHouse(){
      purchase
        .getuserhouse({
          userId : this.userId
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.depotData = res.warehouses;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//获取用户的所有仓库
    handleEdit(index,rows){
        this.dialogFormVisibleUP =true;
        this.sizeForm = rows;
        
        console.log(this.sizeForm);
    },//更新供应商基本信息
    Supupdate(){
        purchase
        .updatesup(this.sizeForm)
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.$message.success(this.$t('other.a1231'));
            this.getUserSuplist();
            this.dialogFormVisibleUP = false;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//更新供应商信息
    handleDelete(index,rows){
      purchase
        .deletesup({
          supplierId  : rows.id
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.$message.success(this.$t('other.a1232'));
            this.getUserSuplist();
          }else{
            this.$message.warning(res.msg);
          }
        });
      console.log(index)
      console.log(rows)
    },//删除某个供应商
    auditChange(){
      console.log(this.auditType);
      if(this.auditType == null){
          this.$message.warning(this.$t('other.a1233'));
      }else{
          purchase
        .updatepurchasestatus({
          purchaseOrderId    : this.purchaseOrderIdAU,
          purchaseOrderStatus : this.auditType,
          userId : this.userId,
          description  : this.inputStatus
        })
        .then((res) => {
         
          if(res.code =='ok'){
              //  console.log(res);
               this.getUserpurchase();
               this.auditStatus = false;
               this.$message.success(this.$t('other.a1234'));
               this.auditType = null;
          }else{
            this.$message.warning(res.msg);
          }
        });
      }
      
    },//更新采购单状态
    editClick(index,rows){
        console.log(rows);
        console.log(rows.orderStatus);
        if(rows.orderStatus == 'FIRST_AUDITING' || rows.orderStatus == 'SECOND_AUDITING'){
            this.$message.warning(this.$t('other.a1235'));
            return
        }else if(rows.orderStatus == "RECEIVED_BY_STOCK"){
            this.$message.warning(this.$t('other.a1236'));
            return
        }
        
        this.auditStatus = true;
        // this.auditType = rows.orderStatus;
        this.purchaseOrderIdAU = rows.purchaseOrderId;

    },//修改采购单状态
    getCommentData(purchaseOrderId){
        purchase
        .getcomment({
          purchaseOrderId    : purchaseOrderId
        })
        .then((res) => {
         
          if(res.code =='ok'){
               console.log(res);
               this.comments = res.comments;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//获取采购单的评论
    getDetail(purchaseOrderId){
      purchase
        .getorderdetil({
          purchaseOrderId   : purchaseOrderId
        })
        .then((res) => {
         
          if(res.code =='ok'){
               console.log(res);
               this.purchaseOrderData = res.purchaseOrderObject.purchaseOrderProducts;
               this.suppliersData = res.purchaseOrderObject.suppliers;
               this.formLabelAlign = res.purchaseOrderObject;
               console.log(this.formLabelAlign);
               this.getCommentData(purchaseOrderId);
               this.getattribute(purchaseOrderId);
              //  this.particulars = true;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//
    orderDetail(index,rows){
        this.additsta = false;
        purchase
        .getorderdetil({
          purchaseOrderId   : rows.purchaseOrderId
        })
        .then((res) => {
         
          if(res.code =='ok'){
               console.log(res);
               this.purchaseOrderData = res.purchaseOrderObject.purchaseOrderProducts;
               this.suppliersData = res.purchaseOrderObject.suppliers;
               this.formLabelAlign = res.purchaseOrderObject;
               console.log(this.formLabelAlign);
               this.getCommentData(rows.purchaseOrderId);
               this.getattribute(rows.purchaseOrderId);
               this.particulars = true;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },
    orderDeril(index,rows){
      console.log(rows);
      this.additsta = true;
        purchase
        .getorderdetil({
          purchaseOrderId   : rows.purchaseOrderId
        })
        .then((res) => {
         
          if(res.code =='ok'){
               console.log(res);
               this.purchaseOrderData = res.purchaseOrderObject.purchaseOrderProducts;
               this.suppliersData = res.purchaseOrderObject.suppliers;
               this.formLabelAlign = res.purchaseOrderObject;
               console.log(this.formLabelAlign);
               this.getCommentData(rows.purchaseOrderId);
               this.getattribute(rows.purchaseOrderId);
               this.particulars = true;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//查看某个采购单详情
    getattribute(purchaseOrderId ){
          purchase
        .getattribute({
          purchaseOrderId    : purchaseOrderId  
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
              this.accessData = res.purchaseOrderAttributes;
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//获取采购单自建属性
    deletePur(index,rows){
      console.log(rows.purchaseOrderId);
      this.$confirm(this.$t('other.a608'),this.$t("other.a142"),{
                    confirmButtonText:this.$t('other.a145'),
                    cancelButtonText: this.$t('other.a146'),
                    type: 'warning'
                }).then(() => {
                    purchase
        .deletepurord({
          purchaseOrderId   : rows.purchaseOrderId 
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.$message.success(this.$t('other.a1232'));
            this.getUserpurchase();
          }else{
            this.$message.warning(res.msg);
          }
        });
                })
      
    },//删除某个采购单
    getUserSuplist(){
      purchase
        .getsuplist({
          userId : this.userId,
        })
        .then((res) => {
          console.log(res);
          if(res.code =='ok'){
            this.gridData = res.productSuppliers
          }else{
            this.$message.warning(res.msg);
          }
        });
    },//获取用户的供应商
    successAdd(){
      this.dialogFormVisible =false;
      console.log(this.sizeForm);
      purchase
        .cteatesup(this.sizeForm)
        .then((res) => {
          if(res.code == 'ok'){
            this.$message.success(this.$t('other.a1237'));
            this.getUserSuplist();
          }else{
            this.$message.warning(res.msg);
          }
        });
    },
    createSupplier() {
      this.dialogFormVisible = true;
    }, //创建供应商
    openList(){
      this.dialogTableVisible =true;
    },//查看供应商列表
    opentransit(){
      this.depot = true;
    },//查看中转仓
    toggleSelection() {
      let routeData2 = this.$router.resolve({
        name: "purchuseList",
      });
      window.open(routeData2.href, "_blank");
      this.$confirm(this.$t('other.a1238'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a1010'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
				}).then(() => {
					this.getUserpurchase()
				})
      // this.$router.push({
      // 	name: "purchuseList",
      // })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    renderTime(date) {
			  var dateee = new Date(date).toJSON();
			  return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
			},
    getPurchaseLisr() {
      purchase
        .getUserCache({
          userId: this.userId,
        })
        .then((res) => {
          console.log(res);
        });
    },
  },
};
</script>

<style lang="scss" >

.el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
.produ_cc{
 
  display: flex;
	align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.pic-wrapper-quantity {
			position: absolute;
			top: 0;
			right: 0;
			display: inline-block;
			min-width: 15px;
			min-height: 15px;
			line-height: 15px;
			background-color: red;
			font-size: 8px;
			color: #fff;
			text-align: center;
		}

.storeBox{
			border: 1px solid #eee;
			cursor: pointer;
			display:inline-block;
			margin-bottom:3px;
			padding:6px 8px;
			margin:0 3px
			
			
			
		}
    .ttpactive{
			background-color: #1890ff;
			color: #fff;
		}
	    .ttpactive:hover{
			background-color: #40a9ff;
			color: #fff;
		}
		
	
		
		.desc{
			min-width:80px
		}
      .scrollbar-wrap{
        overflow-x: hidden;
      }
      
.el-icon-edit{
  cursor: pointer;
  color: #1890ff;
}
.auditbody{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.home_body {
  // margin-top: 30px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  // background: #f4f6f8;
  margin: 10px;
}
.title {
  width: 100%;
  background-color: #fff;
  font-size: 20px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.title_body{
  display: flex;
  margin-top: 15px;
 
}
.pur_box {
  width: 100%;
  // height: 100vh;
  margin-bottom: 150px;
}
.block{
  position: fixed;
  bottom: 10px;
  right: 10px;
}
.btn_box {
  font-size: 14px;
  margin-top: 15px;

  .btn_item {
    display: inline-block;
    box-sizing: border-box;
    padding: 4px 8px;
    border: 1px solid #d9d9d9;
    margin-right: 5px;
    cursor: pointer;
  }

  .btn_desc {
    margin-right: 15px;
    min-width: 65px;
  }

  .btn_item_active {
    background-color: #1890ff;
    color: #fff;
  }

  .btn_outer {
    padding: 5px 0 10px 0;
  }
}
</style>